// src/features/landing/presentation/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container footer-inner">
                <div className="footer-col">
                    <h4>Rising Brokers</h4>
                    <p>
                        대표자: 김준수
                        <br />
                        사업자등록번호: 352-81-03886
                    </p>
                    <p>
                        Tel: 02-858-2014
                    </p>
                </div>
                <div className="footer-col">
                    <h4>Explore</h4>
                    <ul>
                        <li>
                            <Link to="/about">라이징 브로커즈 소개</Link>
                        </li>
                        <li>
                            <Link to="/service">서비스</Link>
                        </li>
                        <li>
                            <Link to="/premium">프리미엄 채용관</Link>
                        </li>
                        <li>
                            <Link to="/contact">제휴문의</Link>
                        </li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Contact</h4>
                    <p>
                        서울특별시 금천구 디지털로10길 37, 2014
                    </p>
                </div>
            </div>
            <div className="footer-bottom">
                Copyright © {year} Rising Brokers. All Rights Reserved.
            </div>
        </footer>
    );
}
